import React from 'react';
import Paragraph from '../../Typography/Paragraph';
function MessageBlockBody(_a) {
    var children = _a.children, id = _a.id;
    return (React.createElement("div", { className: "elmo-message-block__body", "data-testid": "elmo-message-block-body-".concat(id || 'default') },
        React.createElement(Paragraph, null, children)));
}
export default MessageBlockBody;
